var lib_core = require("lib-core");

var AssetUpdaterStateMachine = function (root, model, collection, url) {
    var self = this;

    this.root = root;
    this.model = model;
    this.collection = collection;
    this.url = url;

    lib_core.StateMachine.call(self);

    this.editTransition = self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.ASSET_EDIT;
        },

        function(cEvent){
            var oldInstance = cEvent.element();
            var url = self.url + '?assetid='+oldInstance.ancestor().root.header["assetId"];
            var win = window.open(url, '_blank');
            if(win)
                win.focus();
            else
                logError("AssetUpdater", new Error("Could not open asset in editor"), logError.criticality.MAJOR);
        }
    );

    this.updateTransition = self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.ASSET_UPDATE;
        },

        function(cEvent){
            var oldInstance = cEvent.element();
            var assetId = oldInstance.ancestor().root.header["assetId"];
            var assetType = oldInstance.ancestor().root.header["assetType"];
            var assetVersion = cEvent.data('value');

            if(assetVersion == 'new') {
                var resource = oldInstance.ancestor().root.getAsset(true);
                self.root.dataLoader.dataManager.createResourceVersion(assetType, assetId, 'Version ' + resource.getNextVersionNumber(), 'Automatically generated', true);
                assetVersion = resource.getNextVersionNumber();
            }

            var description = self.root.dataLoader.getDescription(assetType, assetId, assetVersion);

            self.root.rec();
            oldInstance.ancestor(description);
            self.root.stopRec();
        }
    );

    this.updateTransition = self.addTransition("idle", "idle",
        function(cEvent){
            return cEvent.type() == lib_core.GuiEvents.ASSET_FORK;
        },

        function(cEvent){
            var oldInstance = cEvent.element();
            var assetId = oldInstance.ancestor().root.header["assetId"];
            var assetType = oldInstance.ancestor().root.header["assetType"];

            var clonedRes = self.root.dataLoader.dataManager.cloneResource(assetType, assetId, true);
            var clonedResAssetId = clonedRes['id'];

            var resource = self.root.dataLoader.dataManager.getResource(assetType, clonedResAssetId, true);
            var assetVersion = resource.getNextVersionNumber();
            self.root.dataLoader.dataManager.createResourceVersion(assetType, clonedResAssetId, 'Version ' + assetVersion, 'Automatically generated', true);

            var description = self.root.dataLoader.getDescription(assetType, clonedResAssetId, assetVersion);

            self.root.rec();
            oldInstance.ancestor(description);
            self.root.stopRec();
        }
    );
};

lib_core.inherit(AssetUpdaterStateMachine, lib_core.StateMachine);

module.exports = AssetUpdaterStateMachine;
